export function informedConsentBuyerTenantCBDP() {
return [   // Release 2026-08-12 09:50:07
//  {
//    page: 0,
//  name: "Logo",
//  type: "logo",
//  top: 28.673,
//  left: 53,
//  width: 240,
//  height: 36,
//  }, 
{
   page: 0,
   name: "Buyer Broker Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 135.393,
   left: 304.2,
   width: 269.171,
   height: 12.927
}
,
{
   page: 1,
   name: "Buyer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 198,
   left: 191.64,
   width: 376.32,
   height: 13.44
}
] }
